const translation = {
  // Nav
  nav_home: "Startseite",
  nav_back_home: "Zurück zur Startseite",
  nav_about: "Über uns",
  nav_menu: "Speisekarte",
  nav_gallery: "Galerie",
  nav_testimonials: "Bewertungen",
  nav_contact: "Kontakt",
  nav_reserve: "Tisch reservieren",

  // Hero
  hero_since: "Seit 1994",
  hero_title_1: "Cantinho",
  hero_title_2: "do Cais",
  hero_subtitle: "Azoreanische Küche mit authentischen Aromen und familiärer Atmosphäre, in der man sich wie zu Hause fühlt.",
  hero_cta_menu: "Speisekarte",
  hero_cta_reserve: "Tisch reservieren",
  hero_scroll: "Entdecken",

  // About
  about_label: "Unsere Geschichte",
  about_title_1: "Tradition und Leidenschaft",
  about_title_2: "in jedem Gericht",
  about_p1: "Cantinho do Cais entstand aus einer tiefen Verbundenheit mit dem Meer und der azoreanischen Fischereitradition. Ursprünglich wurde das Restaurant in Porto Formoso gegründet, direkt neben dem alten Kai, an dem die traditionellen Fischerboote anlegten. Seinen Namen verdankt das Restaurant der Nähe zur kleinen örtlichen Fischauktion — jenem Ort, an dem der frische Fisch direkt aus den Netzen in unsere Küche gelangte.",
  about_p2: "Mit der Zeit kamen neue Herausforderungen und das Restaurant fand in São Brás ein neues Zuhause. Auch wenn der alte Kai heute hinter uns liegt, blieben die Seele, der Name und die Tradition über all die Jahre hinweg erhalten — geprägt von Erinnerungen, Respekt vor dem Meer und der Leidenschaft für die azoreanische Küche.",
  about_p3: "Bis heute sind wir ein stolz familiengeführtes Restaurant, in dem Einfachheit, Gastfreundschaft und die authentischen Aromen der Insel São Miguel zusammenkommen. Jeden Tag hält Herr Jorge den Geist des frischen Fischkaufs lebendig und besucht persönlich den Markt, um die besten Exemplare auszuwählen, die in unsere Küche gelangen.",
  about_p4: "Als Spezialisten für Fisch und regionale Küche ehren wir die azoreanische Gastronomie mit unserer berühmten Fischsuppe, dem traditionellen Fischeintopf und Spezialitäten aus den Gewässern unserer Küste — darunter Geißbrasse, Schwarzer Rotbarsch, Gabeldorsch, Kaiserbarsch, Thunfisch, Oktopus, sowie andere täglich frisch ausgewählte Fisch- und Meeresfrüchte. Ob frisch gegrillte Fischgerichte oder aufwendigere Rezepte der azoreanischen Küche — jedes Gericht feiert den authentischen Geschmack der Insel. Zwischen traditionellen Geheimnissen und hausgemachten Desserts öffnen wir unsere Türen, damit sich jeder Gast wirklich wie zu Hause fühlt.",
  about_cta: "Unser Team kennenlernen",
  about_stat_1_num: "30+",
  about_stat_1_label: "Jahre Erfahrung",
  about_stat_2_num: "90%+",
  about_stat_2_label: "Lokale Zutaten",
  about_stat_3_num: "4.5★",
  about_stat_3_label: "Durchschnittsbewertung",
  about_quote_text: "Ein unvergessliches kulinarisches Erlebnis.",

  // Menu Categories & Prices
  menu_label: "Speisekarte",
  menu_title_1: "Entdecken Sie unsere",
  menu_title_2: "einzigartigen Aromen",
  menu_subtitle: "Eine sorgfältig zusammengestellte Auswahl an Gerichten, die den Reichtum der Azoren feiern",
  menu_from: "Ab",
  menu_view: "Gerichte ansehen",
  menu_cat_starters: "Vorspeisen",
  menu_cat_starters_desc: "Napfschnecken, Muscheln, Garnelen, Fischsuppe und Insel-Snacks für einen geschmackvollen Einstieg.",
  menu_cat_fish: "Fischgerichte",
  menu_cat_fish_desc: "Fischeintopf, Oktopus, Schwarzer Rotbarsch, Gabeldorsch, Kaiserbarsch und mehr, vom Grill oder in aufwendigen Gerichten.",
  menu_cat_meat: "Fleischgerichte",
  menu_cat_meat_desc: "Braten, Kalbssteak und andere Fleischgerichte mit den besten azoreanischen Zutaten zubereitet.",
  menu_cat_vegetarian: "Vegetarische Gerichte",
  menu_cat_vegetarian_desc: "Frische Salate, saisonales Gemüse und vegetarische Gerichte aus lokalen azoreanischen Produkten.",
  menu_cat_kids: "Kindermenü",
  menu_cat_kids_desc: "Ausgewogene und schmackhafte Mahlzeiten, speziell für die Kleinen entworfen.",
  menu_cat_desserts: "Desserts",
  menu_cat_desserts_desc: "Queijadas, traditionelle Früchte und hausgemachte Desserts für einen krönenden Abschluss.",
  menu_price_starters: "€3,50",
  menu_price_fish: "€10,00",
  menu_price_meat: "€10,00",
  menu_price_vegetarian: "€7,50",
  menu_price_kids: "€6,50",
  menu_price_desserts: "€1,20",
  
  // Preisliste & Getränke
  menu_suggestion_question: "Haben Ihnen unsere Empfehlungen gefallen?",
  menu_full_price_list: "Vollständige Preisliste & Weinkarte ansehen",
  menu_section_food: "Speisen",
  menu_section_drinks: "Getränke",
  menu_cat_vines: "Weine",
  menu_cat_reds: "Rotweine",
  menu_cat_whites: "Weißweine",
  menu_cat_greens_alvarinhos: "Grüne Weine & Alvarinho",
  menu_cat_roses: "Roséweine",
  menu_cat_sparkling: "Schaumweine",
  menu_cat_brewery: "Bier vom Fass & Flaschenbiere",
  menu_cat_águas: "Wässer",
  menu_cat_sumos: "Säfte",
  menu_cat_licores: "Liköre",
  menu_cat_aguardentes: "Spirituosen",
  menu_cat_brandys: "Brandys",
  menu_cat_whiskys: "Whiskys",

  // Brewery Items Descriptions / Translations (DE)
  cerveja_fino: "Fino / Kleines Bier (Glas)",
  cerveja_tulipa: "Großes Bier / Tulpe (Glas)",
  cerveja_caneca: "Bierkrug",
  cerveja_garrafa: "Flasche",
  cerveja_panache: "Radler / Panaché (Bier mit Sprite)",
  cerveja_caldeado_cerveja: "Caldeado mit Bier (Bier-Wein-Mischung)",
  cerveja_caldeado_vinho: "Caldeado mit Wein (Wein-Bier-Mischung)",

  // Waters (DE)
  agua_sem_gas: "Stilles Wasser",
  agua_com_gas: "Wasser mit Kohlensäure (Sprudel)",
  agua_tonica: "Tonic Water",

  // Shots / Riscos (DE)
  bebida_risco_licor: "Likör-Shot",
  bebida_risco_brandy: "Brandy-Shot",
  bebida_risco_whisky: "Neuer Whisky-Shot",

  // Weinregionen
  regiao_alentejo: "Alentejo",
  regiao_douro: "Douro",
  regiao_dão: "Dão",
  regiao_outras_regiões: "Andere Regionen",

  // Modals
  modal_close: "Schließen",
  modal_availability: "Verfügbarkeit je nach Saison und Tagesvorrat",
  modal_starters_title: "Unsere Vorspeisen",
  modal_fish_title: "Unsere Fischgerichte",
  modal_meat_title: "Unsere Fleischgerichte",
  modal_vegetarian_title: "Unsere Vegetarischen Gerichte",
  modal_kids_title: "Unser Kindermenü",
  modal_desserts_title: "Unsere Desserts",

  // All Dishes (Unified list - No duplicates)
  dish_salada_queijo_fresco: "Salat mit Frischkäse",
  dish_omeletes: "Omeletts",
  dish_salada_feijao: "Bohnensalat",
  dish_filetes_fritos: "Gebratene Fischfilets",
  dish_lombinhos: "Schweinefilet",
  dish_hamburguer_prato: "Hamburger auf dem Teller",
  dish_note_sob_consulta: "(auf Anfrage)",
  dish_note_por_encomenda: "(auf Bestellung)",
  dish_camarao: "Garnelen",
  dish_favas_guisadas: "Geschmorte Saubohnen",
  dish_iscas_atum: "Thunfisch-Häppchen",
  dish_lapas_grelhadas: "Gegrillte Napfschnecken",
  dish_mexilhoes_grelhados: "Gegrillte Muscheln",
  dish_queijo_curado: "Gereifter Käse",
  dish_queijo_fresco: "Frischkäse",
  dish_sopa_peixe: "Fischsuppe",
  dish_atum: "Thunfisch",
  dish_bacalhau: "Kabeljau",
  dish_chicharros_fritos: "Gebratene Stöcker",
  dish_lulas_grelhadas: "Gegrillter Tintenfisch",
  dish_peixe_grelhado: "Gegrillter Fisch",
  dish_polvo_assado: "Gebratener Oktopus",
  dish_polvo_guisado: "Geschmorter Oktopus",
  dish_molho_peixe: "Fischeintopf",
  dish_assaduras: "Traditionelle Schweinehäppchen",
  dish_bifanas: "Traditionelles Schweineschnitzel",
  dish_bife_novilho: "Kalbssteak",
  dish_peito_frango: "Hähnchenbrust",
  dish_ananas: "Ananas",
  dish_gelados: "Eiscremes",
  dish_queijadas: "Queijadas",

  // Gallery
  gallery_label: "Galerie",
  gallery_title: "Unvergessliche Momente",
  gallery_subtitle: "Eine visuelle Reise durch unsere Küche, Atmosphäre und Aromen",

  // Testimonials
  testimonials_label: "Bewertungen",
  testimonials_title_1: "Was unsere",
  testimonials_title_2: "Kunden sagen",
  testimonials_prev: "Zurück",
  testimonials_next: "Weiter",

  // Reservations & Contact
  reservations_label: "Reservierungen",
  reservations_title: "Ihren Tisch reservieren",
  reservations_subtitle: "Wählen Sie einen Tag und nehmen Sie Kontakt mit uns auf",
  reservations_prev_month: "Vorheriger Monat",
  reservations_next_month: "Nächster Monat",
  reservations_modal_title: "Reservierung für",
  reservations_modal_subtitle: "Wie möchten Sie Ihre Reservierung vornehmen?",
  reservations_phone_title: "Telefonisch reservieren",
  reservations_phone_desc: "Bitte geben Sie während des Anrufs den Tag, die gewünschte Uhrzeit, den Reservierungsnamen, die Personenanzahl und Kontaktdaten an.",
  reservations_phone_cta: "Jetzt anrufen",
  reservations_email_title: "Per E-Mail anfragen",
  reservations_email_desc: "Wir öffnen eine vorausgefüllte E-Mail mit dem ausgewählten Tag. Ergänzen Sie die restlichen Details.",
  reservations_email_cta: "E-Mail senden",
  reservations_close: "Schließen",
  reservations_email_subject: "Reservierungsanfrage - Cantinho do Cais",
  reservations_email_body: "Hallo,\n\nIch möchte eine Reservierung mit folgenden Details vornehmen:\n\nDatum: {date}\nUhrzeit: [ausfüllen]\nName für die Reservierung: [ausfüllen]\nAnzahl der Personen: [ausfüllen]\nKontakt: [ausfüllen]\n\nVielen Dank und ich freue mich auf Ihre Rückmeldung.\n\n---\n⚠️ Hinweis: Wenn diese Reservierung weniger als 12 Stunden im Voraus vorgenommen wird, rufen Sie bitte das Restaurant an (296 442 631), um die Verfügbarkeit zu bestätigen.",
  contact_label: "Kontakt",
  contact_title: "Besuchen Sie uns",
  contact_subtitle: "Wir erwarten Sie in São Brás, Azoren",
  contact_address_label: "Adresse",
  contact_address: "Rua do Ramal 1, 9625-510 São Brás",
  contact_phone_label: "Telefon",
  contact_phone: "296 442 631",
  contact_hours_label: "Öffnungszeiten",
  contact_hours_1: "Montag, Dienstag, Donnerstag bis Sonntag: 12:00 – 22:00 Uhr",
  contact_hours_2: "Mittwoch: Geschlossen",
  contact_form_title: "Senden Sie uns eine Nachricht",
  contact_form_name: "Name",
  contact_form_email: "E-Mail",
  contact_form_message: "Nachricht",
  contact_form_submit: "Nachricht senden",
  contact_form_success: "Nachricht erfolgreich gesendet! Wir melden uns in Kürze.",
  contact_form_error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
  contact_call_cta: "Jetzt anrufen",

  // Footer
  footer_tagline: "Azoreanische Küche mit authentischen Aromen in São Brás",
  footer_nav_title: "Schnellzugriff",
  footer_info_title: "Informationen",
  footer_legal_title: "Rechtliches",
  footer_privacy: "Datenschutzrichtlinie",
  footer_terms: "Nutzungsbedingungen",
  footer_cookies: "Cookie-Richtlinie",
  footer_copyright: "© 2026 Cantinho do Cais. Alle Rechte vorbehalten.",
  footer_developed_by: "Entwickelt von Ponto Zero Apps",
  footer_newsletter_title: "Neuigkeiten & Angebote",
  footer_newsletter_desc: "Erhalten Sie unsere neuesten Nachrichten und Sonderangebote",
  footer_newsletter_placeholder: "Ihre E-Mail",
  footer_newsletter_cta: "Abonnieren",
  footer_made_with: "Gemacht mit",
  footer_in: "auf den Azoren",
  footer_complaints: "Beschwerdebuch",

  // --- PÁGINAS LEGAIS (LEGAL PAGES) ---

  // Cookies
  cookies_title: "Cookie-Richtlinie",
  cookies_intro_1: "Die Website von ",
  cookies_intro_2: " verwendet Cookies, um sicherzustellen, dass wir Ihnen das bestmögliche Surferlebnis bieten.",
  cookies_h1: "1. Was sind Cookies?",
  cookies_p1: "Cookies sind kleine Textdateien, die über Ihren Webbrowser auf Ihrem Computer oder Mobilgerät gespeichert werden. Diese Dateien ermöglichen es der Website, sich über einen bestimmten Zeitraum an Ihre Aktionen und Präferenzen (wie die gewählte Sprache) zu „erinnern“.",
  cookies_h2: "2. Welche Cookies verwenden wir?",
  cookies_p2_1: "Unsere Website verwendet ausschließlich ",
  cookies_p2_2: " und ",
  cookies_p2_strong1: "Zwingend notwendige Cookies",
  cookies_p2_strong2: "Funktionale Cookies",
  cookies_li1_strong: "Sprach-Cookies:",
  cookies_li1_text: " Werden verwendet, um sich an die Sprache (Portugiesisch, Englisch oder Deutsch) zu erinnern, die Sie zum Durchsuchen der Website ausgewählt haben, damit Sie diese bei jedem Besuch einer neuen Seite nicht erneut auswählen müssen.",
  cookies_li2_strong: "Leistungs-/Analyse-Cookies:",
  cookies_li2_text: " Wir verwenden anonyme Analysetools, die keine personenbezogenen Daten sammeln (weder die IP-Adresse verfolgen noch den Benutzer identifizieren) und nur zur Zählung von Besuchen und zur Verbesserung der Website-Leistung dienen.",
  cookies_p3: "Wir verwenden keine Cookies für gezielte Werbung oder Drittanbieter-Marketing.",
  cookies_h3: "3. Wie kann man Cookies verwalten?",
  cookies_p4: "Sie können Cookies jederzeit in den Einstellungen Ihres Browsers blockieren oder löschen. Durch die Deaktivierung von Cookies können jedoch einige Funktionen der Website (wie das Speichern der Sprache) möglicherweise nicht mehr richtig funktionieren. Weitere Informationen zur Verwaltung von Cookies finden Sie im „Hilfe“-Bereich Ihres Browsers.",

  // Privacidade
  privacy_title: "Datenschutzrichtlinie",
  privacy_intro_1: "Das ",
  privacy_intro_2: " respektiert die Privatsphäre aller Nutzer seiner Website und verpflichtet sich, die persönlichen Daten, die jeder Nutzer teilen möchte, zu schützen.",
  privacy_h1: "1. Datenerhebung",
  privacy_p1: "Beim Surfen auf unserer Website erfassen wir nicht automatisch personenbezogene Daten. Die einzigen personenbezogenen Daten, auf die wir Zugriff haben, sind jene, die Sie uns freiwillig zur Verfügung stellen, wenn Sie uns telefonisch kontaktieren (wie Name, Telefonnummer und Reservierungsdetails).",
  privacy_h2: "2. Datennutzung",
  privacy_p2: "Die bereitgestellten Daten werden ausschließlich verwendet für:",
  privacy_li1: "Die Beantwortung von Informations- oder Kontaktanfragen.",
  privacy_li2: "Die Bearbeitung und Verwaltung von Tischreservierungsanfragen.",
  privacy_li3: "Die Verbesserung der Benutzererfahrung in unserem Raum.",
  privacy_h3: "3. Datenweitergabe",
  privacy_p3: "Cantinho do Cais verkauft, vermietet oder teilt Ihre personenbezogenen Daten nicht mit Dritten, es sei denn, dies ist zur Erfüllung gesetzlicher Verpflichtungen zwingend erforderlich.",
  privacy_h4: "4. Datenaufbewahrung",
  privacy_p4: "Ihre Daten werden nur so lange gespeichert, wie es für den Zweck, für den sie erhoben wurden, erforderlich ist (z. B. bis zum Datum Ihrer Reservierung oder zum Abschluss Ihrer Kontaktanfrage).",
  privacy_h5: "5. Ihre Rechte",
  privacy_p5: "Gemäß der DSGVO haben Sie das Recht, Auskunft über Ihre personenbezogenen Daten sowie deren Berichtigung oder Löschung zu verlangen. Um diese Rechte auszuüben, kontaktieren Sie uns bitte telefonisch unter 296 442 631 oder persönlich an unserer Adresse: Rua do Ramal 1, 9625-510 São Brás, Azoren.",
  privacy_h6: "6. Änderungen dieser Richtlinie",
  privacy_p6: "Wir behalten uns das Recht vor, diese Datenschutzrichtlinie bei Bedarf zu aktualisieren. Wir empfehlen, diese Seite regelmäßig zu überprüfen.",

  // Termos
  terms_title: "Nutzungsbedingungen",
  terms_intro_1: "Willkommen auf der Website von ",
  terms_intro_2: ". Durch den Zugriff auf diese Website und deren Nutzung stimmen Sie den folgenden Bedingungen zu.",
  terms_h1: "1. Zweck der Website",
  terms_p1: "Diese Website hat ausschließlich informativen Charakter und dient dazu, unseren Raum, unser Menü, unsere Öffnungszeiten, unseren Standort und unsere Kontakt-/Reservierungsmethoden vorzustellen.",
  terms_h2: "2. Menüinformationen und Preise",
  terms_p2: "Wir bemühen uns nach Kräften, sicherzustellen, dass die auf der Website präsentierten Informationen aktuell sind. Preise, Gerichte und Produktverfügbarkeit (insbesondere bei frischem Fisch und Meeresfrüchten) können jedoch ohne vorherige Ankündigung je nach Tagesmarkt und Saison Änderungen unterliegen. Die in der Galerie gezeigten Bilder dienen nur zur Veranschaulichung.",
  terms_h3: "3. Geistiges Eigentum",
  terms_p3: "Alle Inhalte dieser Website, einschließlich Texte, Logos, Grafiken und Bilder, sind Eigentum von Cantinho do Cais oder für unsere Nutzung lizenziert und durch das Urheberrecht geschützt. Die Vervielfältigung, Änderung oder Verbreitung jeglicher Inhalte ohne vorherige Genehmigung ist strengstens untersagt.",
  terms_h4: "4. Reservierungen",
  terms_p4: "Alle Tischreservierungen müssen ausschließlich durch direkten telefonischen Kontakt mit dem Restaurant erfolgen und unterliegen der Bestätigung der Verfügbarkeit.",
  terms_h5: "5. Haftungsbeschränkung",
  terms_p5: "Cantinho do Cais haftet nicht für Schäden oder technische Probleme, die sich aus der Nutzung dieser Website oder externer Links zu anderen Plattformen (wie dem elektronischen Beschwerdebuch) ergeben.",
  terms_h6: "6. Kontakte",
  terms_p6: "Bei Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns bitte telefonisch unter 296 442 631 oder besuchen Sie uns in der Rua do Ramal 1, 9625-510 São Brás."
};

export default translation;